import { graphql, useStaticQuery } from "gatsby";
    import { PatstoreEvent } from '@types';

const useGetEvent = () => {
    const data = useStaticQuery(graphql`
        query AllEvent {
            allPatstoreEvent {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    title
    createdAt
    text
    image
    description
    gallery
    dates
    documents
    file  
  localFile {
            id  
            absolutePath
            url
            publicURL
            childImageSharp {
                gatsbyImageData(
                    width: 1920
                    placeholder: BLURRED
                    formats: [WEBP]
                )
            }
        }
    link
    
                    }
                }
            }
        }
    
        `);


    const allEvent: PatstoreEvent[] =
        data.allPatstoreEvent.edges.map(
            (edge: { node: PatstoreEvent }) => edge.node
        ) || [];

    const findEvent: (id: string) => PatstoreEvent | undefined = (id: string) => {
        const result = allEvent.find((item: PatstoreEvent) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findEvent,
        events: allEvent,
    };
}; 

export default useGetEvent;
